import { Link as RouterLink } from "react-router-dom";
import { Link, Tooltip } from "@mui/material";
import { RoleActionMenu } from "./RoleActionMenu";
import { yearFirstDateTimeFormat } from "src/utils/formatTime";
import { AccessCheckBox } from "./AccessCheckBox";

export const roleListColumns = (isReadOnly) => [
  {
    field: "Actions",
    width: 50,
    sortable: false,
    headerName: "",
    renderCell: ({ id, row }) => {
      return <RoleActionMenu id={id} row={row} />;
    },
  },
  {
    field: "roleName",
    headerName: "Name",
    flex: 1,
    renderCell: ({ value, id }) => (
      <>
        {isReadOnly ? (
          value
        ) : (
          <Link underline="none" component={RouterLink} to={`${id}`}>
            {value}
          </Link>
        )}
      </>
    ),
  },
  {
    field: "createTime",
    headerName: "Creation Time",
    flex: 1,
    type: "date",
    renderCell: ({ value }) => (
      <Tooltip title={yearFirstDateTimeFormat(value)} placement="top">
        <span>{yearFirstDateTimeFormat(value)}</span>
      </Tooltip>
    ),
  },
  {
    field: "createdBy",
    headerName: "Created By",
    flex: 1,
  },
];

export const getRoleDefaultValue = () => ({
  companyName: "",
  roleName: "",
  feature: "",
});

export const featureColumns = (isReadOnly = false, isGrandParent = false) => [
  {
    field: "featureName",
    headerName: "Feature Name",
    flex: 1,
  },
  {
    field: "view",
    headerName: "Read",
    flex: 1,
    renderCell: ({ value, field, id }) => {
      return <AccessCheckBox value={value} field={field} id={id} isReadOnly={isReadOnly} />;
    },
  },
  {
    field: "create",
    headerName: "Create",
    flex: 1,
    renderCell: ({ value, field, id, row }) => {
      const noCreateFeatures = ["ChargerPoint", "Tag", "PriceGroup"];
      const isCreateDisabled = isGrandParent && noCreateFeatures.includes(row?.featureName);
      return <AccessCheckBox value={value} field={field} id={id} isReadOnly={isReadOnly || isCreateDisabled} />;
    },
  },
  {
    field: "update",
    headerName: "Update",
    type: "date",
    flex: 1,
    renderCell: ({ value, field, id }) => {
      return <AccessCheckBox value={value} field={field} id={id} isReadOnly={isReadOnly} />;
    },
  },
  {
    field: "delete",
    headerName: "Delete",
    type: "date",
    flex: 1,
    renderCell: ({ value, field, id }) => {
      return <AccessCheckBox value={value} field={field} id={id} isReadOnly={isReadOnly} />;
    },
  },
];
